import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import {
  DatePicker,
  Loadable,
  SelectField,
  EntitySelector
} from "components/support";

import Moment from "moment";

class SalesmanSalesReportFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: props.filters.dateFrom,
      dateTo: props.filters.dateTo,
      closeWorkaround: false
    };
  }

  static sReportTypes = [{ value: "summary", label: "Resumido" }];

  handleChange = ({ startDate, endDate, reportType }) => {
    const { onChange } = this.props;
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    this.setState(options);

    if (reportType) {
      onChange({ reportType });
    }
  };

  handleClose = () => {
    const { onChange } = this.props;
    this.setState({ closeWorkaround: !this.state.closeWorkaround }, () => {
      onChange({
        dateFrom: this.state.dateFrom,
        dateTo: this.state.dateTo
      });
    });
  };

  render() {
    const {
      loading,
      filters,
      userSearchOptions,
      user,
      onSelectUser
    } = this.props;
    const { dateFrom, dateTo } = this.state;
    const { reportType } = filters;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12} md={8}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={dateFrom}
                endDate={dateTo}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
                onClose={this.handleClose}
              />
            </Col>
            <Col xs={12} md={4}>
              <SelectField
                fullWidth
                options={SalesmanSalesReportFilter.sReportTypes}
                label="Tipo de Relatório"
                value={reportType}
                onChange={(_, reportType) => this.handleChange({ reportType })}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md>
              <EntitySelector
                nullSelection={{ name: "", uuid: null }}
                label="Vendedor"
                title="Selecionar Vendedor"
                value={user.name}
                searchOptions={userSearchOptions}
                onSelect={user => onSelectUser(user)}
                parser={user => ({ key: user.uuid, title: user.name })}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default SalesmanSalesReportFilter;



// WEBPACK FOOTER //
// ./src/components/app/management/salesman-sales-report/filter/index.jsx